module.exports = {"510129001":"晋原街道","510129002":"沙渠街道","510129003":"青霞街道","510129101":"王泗镇","510129103":"新场镇","510129104":"悦来镇","510129105":"安仁镇","510129106":"䢺江镇","510129107":"花水湾镇","510129108":"西岭镇","510129119":"鹤鸣镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510129.json
// module id = 2397
// module chunks = 0